module.exports = __webpack_public_path__ + "img/problem_solving.e114904f.svg";